import { getEasternTime } from "../../helpers/dateHelpers";

export const requestlistNoData = [
  {
    id: "1",
    requested_on: "useSpecialDayOffContext.sdoInfoTabData.sdo_year",
    requested_from_dt: "-",
    requestedOn: "-",
    status: "Not Requested Yet",
  },
];
export const positionReqStatusType = {
  PREVIOUSLY_APPROVED: "PREVIOUSLY APPROVED",
  APPROVED: "approved",
  DECLINED: "declined",
  REVOKED: "revoked",
  PREVIOUSLY_DECLINED: "PREVIOUSLY DECLINED",
  PENDING_APPROVAL: "pending approval",
  PENDING_DECLINE: "pending decline",
  PREV_APPROVED: "PREV APPROVED",
  PREV_DECLINED: "PREV DECLINED",
};

export const getStyleForStatus = (status) => {
  switch (status) {
    case positionReqStatusType.PREVIOUSLY_APPROVED:
      return {
        backgroundColor: "#108C0C",
      };
    case positionReqStatusType.APPROVED:
      return {
        backgroundColor: "#108C0C",
      };
    case positionReqStatusType.DECLINED:
      return {
        backgroundColor: "#A42125",
      };
    case positionReqStatusType.PREVIOUSLY_DECLINED:
      return {
        backgroundColor: "#A42125",
      };
    case positionReqStatusType.REVOKED:
      return {
        backgroundColor: "#737373",
      };
    case positionReqStatusType.PENDING_APPROVAL:
      return {
        backgroundColor: "#ffffff",
        borderRadius: "7px",
        border: "1px solid #108C0C",
        color: "#108C0C",
      };
    case positionReqStatusType.PENDING_DECLINE:
      return {
        backgroundColor: "#ffffff",
        borderRadius: "7px",
        border: "1px solid #A42125",
        color: "#A42125",
      };
    default: {
    }
  }
};

export const positionPublishStatus = {
  PENDING: "PENDING",
  PUBLISHED: "PUBLISHED",
};

export const sdoCycleStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  OVERDUE: "OVERDUE",
};

export const getPositionFormatted = (position) => {
  return (
    position?.pos?.base +
    " | " +
    position?.pos?.equipment +
    " | " +
    position?.pos?.position
  );
};

export const positionReqListColumns = [
  {
    field: "position",
    headerName: "Position",
    width: 110,
    editable: false,
  },
  {
    field: "pilot",
    headerName: "Pilot",
    width: 200,
    editable: false,
  },
  {
    field: "seniority",
    headerName: "Seniority",
    width: 180,
    editable: false,
  },
  {
    field: "aq",
    headerName: "AQ",
    width: 150,
    editable: false,
  },
  {
    field: "requestedFromDate",
    headerName: "Dates Requested",
    width: 220,
    editable: false,
  },
  {
    field: "status",
    headerName: "Status",
    width: 250,
    editable: false,
  },
  {
    field: "reason",
    headerName: "Reason",
    width: 250,
    editable: false,
  },
];

export const sdoRequestlistNoData = [
  {
    id: "1",
    position: "-",
    pilot: "-",
    seniority: "-",
    aq: "-",
    requestedFromDate: "-",
    status: "-",
    reason: "-",
  },
  {
    id: "2",
    position: "-",
    pilot: "-",
    seniority: "-",
    aq: "-",
    requestedFromDate: "-",
    status: "-",
    reason: "-",
  },
];

export const isPublishedWithOtherReqs = (position) => ((position?.status === positionPublishStatus.PUBLISHED) && (Number(position?.totalRequests) > 0));

export const getLastPublishedDate = (profile, positions) => {
    if(!profile || !positions) return getEasternTime();
    const sortedPositionsArray = positions.filter(position => (position?.status === positionPublishStatus.PUBLISHED && Number(position?.publishedBy) === profile?.EmployeeId)).sort((a,b)=> getEasternTime(b?.publishedOn).getTime() - getEasternTime(a?.publishedOn).getTime());
    
    return sortedPositionsArray && sortedPositionsArray.length ? getEasternTime(sortedPositionsArray[0].publishedOn) : getEasternTime();
}

export const sortDateComparator = (v1, v2) => {
  return new Date(v1).getTime() - new Date(v2).getTime();
};

const statusSortMap = {
  "PREVIOUSLY APPROVED": 0,
  "PREV APPROVED": 1,
  approved: 2,
  "pending approval": 3,
  "pending decline": 4,
  declined: 5,
};

export const sortStatusComparator = (v1, v2) => {
  if (!v1) return;
  return statusSortMap[v1] - statusSortMap[v2];
};

export const sortAlphabetic = (v1, v2) => {
  if (!v1) return;
  return v1.localeCompare(v2);
};

export const sortRequestedOnComparator = (v1, v2) => {
    return new Date(v1).getTime() - new Date(v2).getTime();
}

/**
 * Checks whether sdo requests has any request that is either approved or pre-approved
 * @function
 * @param reqList {Object} : It contains the list of SDO requests 
 * @returns {Boolean} true if even 1 request is either approved or pre-aproved else false
 */

export const isReqApproved = (reqList) => {
    const approvedList = reqList?.reports ? 
                            reqList.reports.filter(rep => rep.recommendedstatus === positionReqStatusType.APPROVED || rep.recommendedstatus === positionReqStatusType.PREVIOUSLY_APPROVED || rep.isPreApproved) : [];
    return approvedList.length > 0;
}

/**
 * Checks whether all sdo requests for a position are previously approved
 * @function
 * @param position {Object} : It contains the list of SDO requests 
 * @returns {Boolean} true if position status is PUBLISHED and total requests is 0 else false
 */

export const areAllRequestsPreApproved = (position) => {
    let areAllReqPreAppr = false;
    if(position){
        const {status = '', totalRequests = 0} = position;
        if(status === 'PUBLISHED' && totalRequests === 0) areAllReqPreAppr = true;
      }
      return areAllReqPreAppr;
}

/**
 * checks number of requests and return singluar or plural version of requests
 * @function
 * @param position {Object} : It contains the list of SDO requests 
 * @returns {String} empty if all requests are prev approved, (#ReqCount request) if count is 0/1, (#ReqCount requests) if request count > 1
 */

export const getNoOfRequests = (position) => {
    if(position){
        const {totalRequests = 0} = position;
        if(areAllRequestsPreApproved(position)) return '';
        else if(totalRequests <= 1) return ` (${totalRequests} request)`;
        else return ` (${totalRequests} requests)`;
    }
    else return '';
}

/**
 * checks if (#reqCount) exists.
 * @function
 * @param position {Array} : It contains splitted details of position data YUL | 330 | CA, (4 requests)
 * @returns {String} empty if all requests are previosuly approved else (#ReqCount requests)
 */

export const renderIfPositionExist = (position) => {
    return position?.length > 1 ? `(${position[1]}` : '';
}

/**
 * checks if View Position button should be enabled or not
 * @function
 * @param positions {Array} : It contains list of positions
 * @returns {Boolean} Even if there is a single posiiton which is PUBLISHED and has previously approved requests, we now allow View position to trigger ViewPosition API hit
 */

export const isAllowViewPosition = (positions) => {
    if(positions?.length > 0){
        const index = positions.findIndex(pos => pos.status === 'PUBLISHED' && pos.totalRequests >= 0);
        return index >= 0;
    }
    return false;
}

/**
 * checks if Cycle is CLOSED and has no pending or published reports
 * @function
 * @param positionsPublishData {Object} : PosiitonsData
 * @returns {Boolean} True, if cycle is CLOSED and there are no pending or published requests available.
 */

export const hidePublishedReportData = (positionsPublishData) => {
    return (positionsPublishData?.cycleStatus === "OPEN") || (positionsPublishData?.totalPending === 0 && positionsPublishData?.totalPublished === 0);
}
